import { render, staticRenderFns } from "./VerProcedimiento.vue?vue&type=template&id=07f694c6&"
import script from "./VerProcedimiento.vue?vue&type=script&lang=js&"
export * from "./VerProcedimiento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports